import { ChangeEvent } from "react"

export const numberFormatOnChangeHandler =  (e: ChangeEvent<HTMLInputElement>,  fieldOnChangeEvent: (e: string | number) => void) => {
    if([undefined, null, ''].includes(e.target.value)) {
        fieldOnChangeEvent('')
    } else {
        fieldOnChangeEvent(Number(e.target.value))
    }
}